import React from "react";
import UserProfile from "features/user-settings/components/UserProfile";

export default function UserProfileView() {
  return <UserProfile />;
}
